var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favourite-product"},[_c('transition',{attrs:{"name":"component-fade"}},[_c('div',{staticClass:"favourite-product__wrap"},[_c('div',{staticClass:"favourite-product__left"},[_c('div',{staticClass:"favourite-product__top"},[_c('div',{staticClass:"favourite-product__top-image"},[_c('router-link',{attrs:{"to":_vm.$localize({
                                    name: 'card',
                                    params: {
                                        item: _vm.product.slug,
                                        id: _vm.product.id,
                                    },
                                })}},[_c('img',{attrs:{"src":_vm.product.image,"alt":"","title":_vm.product.title}})])],1)]),_c('div',{staticClass:"favourite-product__bottom"},[_c('router-link',{staticClass:"favourite-product__bottom-name",attrs:{"to":_vm.$localize({
                                name: 'card',
                                params: {
                                    item: _vm.product.slug,
                                    id: _vm.product.id,
                                },
                            })}},[_vm._v(" "+_vm._s(_vm.product.title)+" ")]),_c('div',{staticClass:"favourite-product__bottom-price"},[(_vm.product.discount_price)?_c('div',{staticClass:"favourite-product__bottom-price-new"},[_vm._v(" "+_vm._s(_vm.product.discount_price)+" ")]):_c('div',{staticClass:"favourite-product__bottom-price-new"},[_vm._v(" "+_vm._s(_vm.product.price)+" ")]),(_vm.product.discount_price)?_c('div',{staticClass:"favourite-product__bottom-price-sale"},[_vm._v(" "+_vm._s(_vm.product.price)+" ")]):_vm._e()]),_c('div',{staticClass:"favourite-product__top-rating"},[_c('star-rating',{attrs:{"max-rating":5,"increment":0.1,"rating":_vm.product.rating,"star-points":[
                                50.0,
                                0.0,
                                55.226,
                                0.274,
                                60.396,
                                1.093,
                                65.451,
                                2.447,
                                70.337,
                                4.323,
                                75.0,
                                6.699,
                                79.389,
                                9.549,
                                83.457,
                                12.843,
                                87.157,
                                16.544,
                                90.451,
                                20.611,
                                93.301,
                                25.0,
                                95.677,
                                29.663,
                                97.553,
                                34.549,
                                98.907,
                                39.604,
                                99.726,
                                44.774,
                                100.0,
                                50.0,
                                99.726,
                                55.226,
                                98.907,
                                60.396,
                                97.553,
                                65.451,
                                95.677,
                                70.337,
                                93.301,
                                75.0,
                                90.451,
                                79.389,
                                87.157,
                                83.457,
                                83.457,
                                87.157,
                                79.389,
                                90.451,
                                75.0,
                                93.301,
                                70.337,
                                95.677,
                                65.451,
                                97.553,
                                60.396,
                                98.907,
                                55.226,
                                99.726,
                                50.0,
                                100.0,
                                44.774,
                                99.726,
                                39.604,
                                98.907,
                                34.549,
                                97.553,
                                29.663,
                                95.677,
                                25.0,
                                93.301,
                                20.611,
                                90.451,
                                16.544,
                                87.157,
                                12.843,
                                83.457,
                                9.549,
                                79.389,
                                6.699,
                                75.0,
                                4.323,
                                70.337,
                                2.447,
                                65.451,
                                1.093,
                                60.396,
                                0.274,
                                55.226,
                                0.0,
                                50.0,
                                0.274,
                                44.774,
                                1.093,
                                39.604,
                                2.447,
                                34.549,
                                4.323,
                                29.663,
                                6.699,
                                25.0,
                                9.549,
                                20.611,
                                12.843,
                                16.544,
                                16.544,
                                12.843,
                                20.611,
                                9.549,
                                25.0,
                                6.699,
                                29.663,
                                4.323,
                                34.549,
                                2.447,
                                39.604,
                                1.093,
                                44.774,
                                0.274,
                                50.0,
                                0.0 ],"inactive-color":"#C4C4C4","active-color":"#FFC315","read-only":true,"show-rating":false}})],1)],1)]),_c('div',{staticClass:"favourite-product__right"},[_c('div',{staticClass:"favourite-product__last"},[_c('div',{staticClass:"favourite-product__bottom-buttons"},[(_vm.product.count === 0)?_c('p',{staticClass:"product-count"},[_vm._v(_vm._s(_vm.$t("productCount")))]):_vm._e(),_c('a',{staticClass:"remove",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.removeItem(_vm.product)}}},[_c('svg',{attrs:{"width":"30","height":"30","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M22.5 23.75C22.5 24.7446 22.1049 25.6984 21.4017 26.4017C20.6984 27.1049 19.7446 27.5 18.75 27.5H10C9.00544 27.5 8.05161 27.1049 7.34835 26.4017C6.64509 25.6984 6.25 24.7446 6.25 23.75V8.75H5V5H10.625L11.875 3.75H16.875L18.125 5H23.75V8.75H22.5V23.75ZM7.5 8.75V23.75C7.5 24.413 7.76339 25.0489 8.23223 25.5178C8.70107 25.9866 9.33696 26.25 10 26.25H18.75C19.413 26.25 20.0489 25.9866 20.5178 25.5178C20.9866 25.0489 21.25 24.413 21.25 23.75V8.75H7.5ZM22.5 7.5V6.25H17.5L16.25 5H12.5L11.25 6.25H6.25V7.5H22.5ZM10 11.25H11.25V23.75H10V11.25ZM17.5 11.25H18.75V23.75H17.5V11.25Z","fill":"#004AAD"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"30","height":"30","fill":"white"}})])])])]),(_vm.product.count !== 0)?_c('a',{staticClass:"buy",attrs:{"href":"","title":_vm.$t('addBasket')},on:{"click":function($event){$event.preventDefault();return _vm.addToBasket(_vm.product)}}},[_c('svg',{attrs:{"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.96647 22.2222C9.75643 22.2222 10.3968 21.5226 10.3968 20.6597C10.3968 19.7967 9.75643 19.0972 8.96647 19.0972C8.17652 19.0972 7.53613 19.7967 7.53613 20.6597C7.53613 21.5226 8.17652 22.2222 8.96647 22.2222Z","fill":"white"}}),_c('path',{attrs:{"d":"M17.6559 22.2222C18.4459 22.2222 19.0863 21.5226 19.0863 20.6597C19.0863 19.7967 18.4459 19.0972 17.6559 19.0972C16.866 19.0972 16.2256 19.7967 16.2256 20.6597C16.2256 21.5226 16.866 22.2222 17.6559 22.2222Z","fill":"white"}}),_c('path',{attrs:{"d":"M21.5213 3.72906C21.4622 3.6494 21.3876 3.58504 21.303 3.54062C21.2183 3.49619 21.1257 3.4728 21.0318 3.47212H7.79641L8.20962 4.86101H20.1991L18.5017 13.1943H8.96611L6.06093 3.14573C6.02951 3.0391 5.97494 2.94236 5.90188 2.86376C5.82882 2.78516 5.73944 2.72704 5.64136 2.69434L3.03496 1.81934C2.95482 1.79244 2.87061 1.78304 2.78714 1.79169C2.70368 1.80034 2.62259 1.82686 2.5485 1.86974C2.39888 1.95635 2.28689 2.10434 2.23715 2.28115C2.18741 2.45796 2.20401 2.64911 2.28329 2.81255C2.36257 2.976 2.49804 3.09834 2.65989 3.15267L4.94208 3.91656L7.85998 13.986L6.81742 14.9166L6.73478 15.0068C6.4769 15.3315 6.33072 15.7442 6.32144 16.1739C6.31216 16.6036 6.44034 17.0234 6.68392 17.361C6.85719 17.5912 7.07737 17.7739 7.32684 17.8945C7.57631 18.015 7.84815 18.0702 8.12062 18.0554H18.7306C18.8992 18.0554 19.0609 17.9823 19.1801 17.8521C19.2993 17.7218 19.3663 17.5452 19.3663 17.361C19.3663 17.1768 19.2993 17.0002 19.1801 16.87C19.0609 16.7397 18.8992 16.6666 18.7306 16.6666H8.01891C7.9457 16.6638 7.87438 16.6405 7.81183 16.5989C7.74928 16.5573 7.69762 16.4987 7.66183 16.4289C7.62604 16.3591 7.60734 16.2804 7.60753 16.2003C7.60772 16.1203 7.62679 16.0417 7.66291 15.9721L9.19497 14.5832H19.0103C19.1572 14.5872 19.3009 14.5353 19.4168 14.4366C19.5327 14.3378 19.6137 14.1982 19.646 14.0416L21.6612 4.31934C21.6805 4.21581 21.678 4.10883 21.6537 4.00654C21.6295 3.90425 21.5842 3.80935 21.5213 3.72906Z","fill":"white"}})]),_vm._v(" "+_vm._s(_vm.$t("buy"))+" ")]):_vm._e()])])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }